import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { Label } from '../components/ui/label';

const CustomerLogin = () => {
  const { login } = useCustomerAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const redirectTo = location.state?.from || '/my-trips';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Email and password are required');
      return;
    }
    setSubmitting(true);
    const { success, error } = await login(email, password);
    setSubmitting(false);
    if (success) {
      toast.success('Welcome back');
      navigate(redirectTo);
    } else {
      toast.error(error);
    }
  };

  return (
    <div className="min-h-screen pt-32 pb-20 px-6 bg-gray-50">
      <Card className="max-w-md mx-auto p-8" data-testid="customer-login-card">
        <h1 className="text-3xl font-bold mb-2 text-black">Welcome back</h1>
        <p className="text-sm text-gray-600 mb-8">Sign in to view and manage your bookings.</p>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label className="mb-2 block text-gray-700">Email</Label>
            <Input
              type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              data-testid="customer-login-email"
            />
          </div>
          <div>
            <Label className="mb-2 block text-gray-700">Password</Label>
            <Input
              type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              data-testid="customer-login-password"
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-black text-white hover:bg-gray-800 h-11 font-semibold"
            disabled={submitting}
            data-testid="customer-login-submit"
          >
            {submitting ? 'Signing in…' : 'Sign In'}
          </Button>
        </form>
        <p className="mt-6 text-sm text-center text-gray-600">
          New to Obsidian?{' '}
          <Link to="/signup" className="text-black font-semibold underline">Create an account</Link>
        </p>
      </Card>
    </div>
  );
};

export default CustomerLogin;
